module.exports = __webpack_public_path__ + "097d5fd98033b13bc710dce43d01cec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cylinder-button.png
// module id = 811
// module chunks = 0